"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockingReason = void 0;
var BlockingReason;
(function (BlockingReason) {
    let type;
    (function (type) {
        type["NO_MORE_SEATS"] = "no-more-seats";
        type["ALREADY_RUNNING_CAMPAIGN"] = "already-running-campaign";
        type["DAYS_TO_DELAY_NOT_ELAPSED"] = "days-to-delay-not-elapsed";
        type["MANUAL_PAYMENT_REVIEW_PENDING"] = "manual-payment-review-pending";
        type["ADJUSTMENTS_NOT_APPROVED"] = "adjustments-not-approved";
        type["NO_AVAILABLE_CODES"] = "no-available-codes";
        type["CONTRACT_NOT_SIGNED"] = "contract-not-signed";
        type["FRAUD"] = "fraud";
        type["OFFER_EXPIRED"] = "offer-expired";
        type["TOUCH_BASE_PENDING"] = "touch-base-pending";
    })(type = BlockingReason.type || (BlockingReason.type = {}));
})(BlockingReason = exports.BlockingReason || (exports.BlockingReason = {}));
